import { TefComs4cs4p } from '@mfe/components/TefComs4cs4p';
import { Purpose } from '@mfe/types/model';
import { html } from 'lit';

//
// renders a single purpose block
//
// {Purpose name}
// {Purpose description}
//   {subscription BLOCK}
export const singlePurpose = function render(this: TefComs4cs4p, purpose : Purpose) : ReturnType<typeof html> {
  return html`
    <div class="slide" data-testid="${purpose.title}">
      <div>
        <div class="container border">
          <div class="typography-display--5 u-st--default">${purpose.title}</div>
          <p class="purpose-description">${purpose.description}</p>
        </div>
        ${purpose.subscriptions.map((subscription) => this.getTemplateFn('singleSubscription')(subscription))}

        <hr class="divider divider--size-flat" />

        <div class="col row align-items-center u-st--default">
          <tef-coms-button text="'${purpose.title}' deaktivieren" data-purpose-id=${purpose.purposeId} @click=${this.withdrawConsentForAllMsisdnsForPurpose}></tef-coms-button>
         </div>
      </div>
    </div>
  `;
};
